import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { works } from "@/mocks/works";

export default function MovieOva() {
  const movies = works.filter((w) => w.type === "movie");
  const ovas = works.filter((w) => w.type === "ova");
  const mainMovie = movies[0];
  const subMovies = movies.slice(1);

  return (
    <section className="border-y border-background-300/40 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionTitle
          eyebrow="大银幕与限定特辑"
          title="剧场版精选 · OVA专栏"
          desc="完整观影体验的剧场版，与短小精悍的限定 OVA，这里都有精心挑选的片单。"
        />

        <div className="grid gap-6 lg:grid-cols-2">
          {/* 剧场版 */}
          <div>
            <div className="mb-4 flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-xl text-foreground-950">
                <i className="ri-movie-2-line text-primary-400" /> 剧场版精选
              </h3>
              <Link to="/category/movie" className="flex items-center gap-1 text-sm font-bold text-primary-400 hover:text-primary-300">
                更多 <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="flex flex-col gap-4">
              <Link
                to={`/works/${mainMovie.id}`}
                className="group relative flex h-56 overflow-hidden rounded-2xl ring-1 ring-background-300/60"
              >
                <img
                  src={mainMovie.image}
                  alt={`${mainMovie.title} 剧场版海报`}
                  title={`${mainMovie.title} - 口碑剧场版`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 to-transparent" />
                <div className="absolute inset-y-0 left-0 flex w-full max-w-sm flex-col justify-end p-5">
                  <span className="mb-2 w-fit rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-bold text-background-50">
                    {mainMovie.episodes}
                  </span>
                  <h4 className="font-heading text-xl text-foreground-950">{mainMovie.title}</h4>
                  <p className="mt-1 line-clamp-2 text-xs text-foreground-600">{mainMovie.description}</p>
                </div>
              </Link>
              <div className="grid grid-cols-2 gap-4">
                {subMovies.map((m) => (
                  <Link
                    key={m.id}
                    to={`/works/${m.id}`}
                    className="group flex gap-3 rounded-2xl bg-background-50 p-2.5 ring-1 ring-background-300/50 transition-all hover:ring-primary-500/50"
                  >
                    <img
                      src={m.image}
                      alt={`${m.title} 海报`}
                      title={m.title}
                      className="h-16 w-12 shrink-0 rounded-lg object-cover object-top"
                    />
                    <div className="min-w-0">
                      <h4 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-400">{m.title}</h4>
                      <p className="mt-1 flex items-center gap-1 text-xs font-bold text-secondary-400">
                        <i className="ri-star-fill" /> {m.score.toFixed(1)}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {/* OVA */}
          <div>
            <div className="mb-4 flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-xl text-foreground-950">
                <i className="ri-disc-line text-accent-400" /> OVA 专栏
              </h3>
              <Link to="/category/ova" className="flex items-center gap-1 text-sm font-bold text-primary-400 hover:text-primary-300">
                更多 <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="flex flex-col gap-4">
              {ovas.map((o) => (
                <Link
                  key={o.id}
                  to={`/works/${o.id}`}
                  className="group flex items-center gap-4 rounded-2xl bg-background-50 p-3 ring-1 ring-background-300/50 transition-all hover:-translate-y-0.5 hover:ring-accent-500/50"
                >
                  <img
                    src={o.image}
                    alt={`${o.title} OVA海报`}
                    title={`${o.title} - OVA特辑`}
                    className="h-24 w-16 shrink-0 rounded-xl object-cover object-top"
                  />
                  <div className="min-w-0 flex-1">
                    <h4 className="truncate text-base font-bold text-foreground-950 group-hover:text-accent-400">
                      {o.title}
                    </h4>
                    <p className="mt-1 text-xs text-foreground-500">{o.episodes} · {o.studio}</p>
                    <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                      {o.description}
                    </p>
                  </div>
                  <span className="shrink-0 text-sm font-bold text-accent-400">{o.score.toFixed(1)}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}